module.exports = __webpack_public_path__ + "static/media/1009301.a74d6d94.png";